import { BitfODataResponseMapper } from '@bitf/core/parsers/odata-parser';

export class AppResponseMapper extends BitfODataResponseMapper {}
